export const GET_POLICY = 'v1/getPolicy'
export const GET_POLICY_PAYMENT = 'v1/getPolicyForPaymentValidation'
export const IS_BLOCK_POLICY = 'v1/is/blockPolicy'
export const REVERSE_FEED = 'v1/saveQuickPayReverseFeedData'
export const SAVE_PAYMENT_DETAILS = 'v1/savePaymentDetails'
export const GET_OTP = 'v1/getOTP'
export const Validate_Otp = 'v1/validateOTP'
export const generate_orderID = 'v1/generate/orderid'
export const PAYMENT_VERIFY = 'v1/payment/verify'
export const MIS_DUMP_LOGIN = 'auth/signin'
export const MIS_DUMP_DOWNLOAD = 'v1/misdata/getExcelExportAgent?'
export const NonAGent_MIS_DUMP_DOWNLOAD = 'v1/misdata/getExcelExportNonAgent?'
export const Policy_Excel_Download = 'v1/getPaymentDetailsExcel?uniqueIdentifier='
export const Policy_Excel_agent_Download = 'v1/agent/getPaymentDetailsExcel?uniqueIdentifier='
